<!-- Card Header -->
<div class="chat-card-header card shadow-sm mb-3">
  <div class="card-body d-flex align-items-center justify-content-between">
    <div class="d-flex align-items-center">
      <i class="fas fa-comments fa-2x text-primary me-3"></i>
      <div>
        <h5 class="mb-0">Xaintro Community Chat</h5>
        <small class="text-muted">Connect with your friends & colleagues</small>
      </div>
    </div>
    <div class="header-actions d-flex align-items-center gap-2">
      <button class="btn btn-sm btn-outline-primary">
        <i class="fas fa-user-plus"></i> Invite
      </button>
      <button class="btn btn-sm btn-outline-secondary">
        <i class="fas fa-cog"></i>
      </button>
    </div>
  </div>
</div>

<div class="card p-3">
  <div class="row">
    <div class="col-md-6 col-sm-12">
      <div class="chat-box-container">
        <!-- Header -->
        <div class="chat-header">
          <div class="user-info">
            <img [src]="currentUser?.profilePicture || 'assets/default-avatar.png'" class="avatar" alt="User" />
            <div>
              <h6 class="fw-bold mb-0 text-light">{{ currentUser?.name || 'Chat User' }}</h6>
              <small class="status">
                <i class="fas fa-circle text-success me-1"></i> Online
              </small>
            </div>
          </div>

          <div class="chat-actions">
            <i class="fas fa-search" (click)="toggleSearch()" [class.active]="showSearch" style="cursor: pointer;"></i>
            <i class="fas fa-ellipsis-v"></i>
          </div>
        </div>

        <!-- Search Bar -->
        <div class="chat-search" *ngIf="showSearch">
          <input type="text" [(ngModel)]="searchQuery" (input)="filterMessages()" class="form-control"
            placeholder="Search messages..." />
        </div>

        <!-- Messages -->
        <div class="chat-box">
          <div *ngFor="let msg of filteredMessages" class="chat-message"
            [ngClass]="msg.sender?._id === currentUser?._id ? 'self' : 'other'">

            <!-- Receiver -->
            <img *ngIf="msg.sender?._id !== currentUser?._id"
              [src]="msg.sender.profilePicture || 'assets/default-avatar.png'" class="avatar img-fluid" width="40"
              alt="user" />

            <!-- Message Bubble -->
            <div class="message-bubble">
              <p class="message-text" *ngIf="!msg.attachment && !msg.isDeleted">{{ msg.content }}</p>
              <p class="text-muted fst-italic" *ngIf="msg.isDeleted">Message deleted</p>

              <div class="message-file" *ngIf="msg.attachment">
                <img *ngIf="isImageFile(msg.attachment)" [src]="msg.attachment" class="img-file"
                  (click)="openImagePreview(msg.attachment)" />
              </div>

              <small class="timestamp">
                <i class="fas fa-check-double text-success" *ngIf="msg.sender._id === currentUser._id"></i>
                {{ msg.createdAt | date: 'shortTime' }}
              </small>
            </div>

            <!-- Sender -->
            <img *ngIf="msg.sender?._id === currentUser?._id"
              [src]="msg.sender.profilePicture || 'assets/default-avatar.png'" class="avatar img-fluid" width="40"
              alt="user" />
          </div>

        </div>

        <!-- Input -->
        <div class="chat-input">
          <!-- Emoji Icon -->
          <div class="emoji-wrapper">
            <i class="far fa-smile emoji-icon" (click)="toggleEmojiPicker()"></i>

            <!-- Emoji Picker -->
            <div class="emoji-picker" *ngIf="showEmojiPicker">
              <div class="emoji-grid">
                <span *ngFor="let emoji of emojis" (click)="addEmoji(emoji)">{{ emoji }}</span>
              </div>
            </div>
          </div>

          <!-- Attachment -->
          <label class="attachment-btn">
            <i class="fas fa-paperclip"></i>
            <input type="file" accept="image/*" (change)="uploadFile($event)" hidden />
          </label>


          <!-- Message Input -->
          <input type="text" [(ngModel)]="newMessage" placeholder="Type a message..." (keyup.enter)="sendMessage()" />

          <!-- Send -->
          <button class="send-btn" (click)="sendMessage()">
            <i class="fas fa-paper-plane"></i>
          </button>
        </div>

      </div>
    </div>
    <div class="col-md-6 col-sm-12">
      <img src="https://img.freepik.com/premium-vector/live-chat-support-illustration-concept_108061-1009.jpg"
        class="img-fluid" alt="">
    </div>
  </div>

</div>